export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative pt-[64px] min-h-screen flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50 to-accent-100/30"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              每日更新 · 海量资源
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-3">
              耽美漫画网
              <span className="block text-primary-600 text-lg md:text-2xl lg:text-3xl font-medium mt-1">
                免费耽美漫画高清在线阅读平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading italic mb-5">
              零成本追漫，随时随地畅享 BL 漫画世界
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              耽美漫画网专注为耽美爱好者打造一站式免费漫画阅读体验。平台收录海量耽美漫画与
              BL 漫画资源，涵盖古风、现代、奇幻、校园等多种题材，支持高清画质在线阅读。每日
              精选热门新作与经典佳作准时更新，无需注册付费即可畅享全部内容。无论你是资深腐女
              还是刚入坑的新读者，这里都能找到让你心动的作品。
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">5000+</div>
                <div className="text-xs text-foreground-500 mt-0.5">收录作品</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600 font-heading">每日50+</div>
                <div className="text-xs text-foreground-500 mt-0.5">章节更新</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">全站免费</div>
                <div className="text-xs text-foreground-500 mt-0.5">无需付费</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-primary-300 text-primary-700 rounded-md font-medium text-sm hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20danmei%20manga%20style%20illustration%20with%20two%20beautiful%20male%20characters%20in%20flowing%20traditional%20Chinese%20hanfu%20robes%20standing%20together%20under%20a%20blooming%20cherry%20blossom%20tree%20at%20sunset%20warm%20golden%20and%20pink%20lighting%20soft%20romantic%20atmosphere%20delicate%20anime%20art%20style%20rich%20color%20palette%20detailed%20fabric%20textures%20dreamy%20bokeh%20effect%20elegant%20composition&width=680&height=920&seq=hero-main-visual&orientation=portrait"
                alt="耽美漫画网主题视觉 - 古风耽美漫画风格插图"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}